import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { flexibleDateRange } from 'shared/constants/tours'
import { dateFormat, differenceDate, getEndDate } from 'shared/lib/dateFormat'

import { normalizeCalendarDate } from '../../../lib'
import { DaysOfWeek } from '../days/model'
import { DateMonth } from '../month'

import { Props } from './model'

const currentDay = Date.parse(
  dateFormat(new Date(), DATE_FORMAT_LIST.CALENDAR_RENDER),
)

const threeDays = 24 * 60 * 60 * 1000

export const renderMonth = ({
  year,
  month,
  selected,
  hasActiveDays,
  hasSelectedDays,
  isFlexibleDeparture,
  getCurrentDayInfo,
  getDisabledDayInfo,
  getAlreadySelectedDays,
  maxRangeDays,
}: Props) => {
  const dateCurrent = new Date(year, month, 0)

  const firstDayOfMonth = dateFormat(
    dateCurrent,
    DATE_FORMAT_LIST.FIRST_DAY_OF_MONTH,
  )

  const lastDayOfMonth = dateFormat(
    getEndDate({
      date: dateCurrent,
      type: 'month',
    }),
    DATE_FORMAT_LIST.CALENDAR_RENDER,
  )

  const startDate = normalizeCalendarDate(selected?.startDate)
  const endDate = normalizeCalendarDate(selected?.endDate)
  const parsedStartDate = startDate ? Date.parse(startDate) : null
  const parsedEndDate = endDate ? Date.parse(endDate) : null

  const listDays: DateMonth[] = [...Array(dateCurrent.getDate())]?.map(
    (_, index) => {
      const day = index + 1

      const fullDate = `${year}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`

      const parsedFullDate = Date.parse(fullDate)

      const thisDay = Date.parse(fullDate)

      let dateObject = {
        ...getCurrentDayInfo({
          fullDate,
          date: String(day),
        }),
        fullDate,
      }

      // Выбарнные дни
      if (
        parsedStartDate === parsedFullDate ||
        parsedEndDate === parsedFullDate
      ) {
        dateObject = {
          ...dateObject,
          isEnd:
            Boolean(parsedEndDate === parsedFullDate) || isFlexibleDeparture,
          isStart:
            Boolean(parsedStartDate === parsedFullDate) || isFlexibleDeparture,
          type: 'selected',
        }
      }

      // Выбранный день
      if (parsedStartDate === parsedFullDate && !selected?.endDate) {
        dateObject = {
          ...dateObject,
          isStart: false,
          type: 'selected',
        }
      }

      // Дни между выбраннам датами
      if (
        selected?.startDate &&
        selected?.endDate &&
        parsedStartDate &&
        parsedEndDate &&
        thisDay > parsedStartDate &&
        thisDay < parsedEndDate
      ) {
        const dayWeek = new Date(fullDate).getDay() as DaysOfWeek

        dateObject = {
          ...dateObject,
          isStart: Date.parse(firstDayOfMonth) === thisDay,
          isEnd: Date.parse(lastDayOfMonth) === thisDay,
          type: 'range',
          dayOfWeek: dayWeek,
        }
      }

      // Гибкий вылет ±3 дня
      if (isFlexibleDeparture && parsedStartDate) {
        const threeDaysBefore = parsedStartDate - flexibleDateRange * threeDays

        const threeDaysAfter = parsedStartDate + flexibleDateRange * threeDays

        // Показываем область ±3 дня только если выбран один день или есть диапазон
        if (
          thisDay >= threeDaysBefore &&
          thisDay <= threeDaysAfter &&
          thisDay !== parsedStartDate
        ) {
          // Если это день в диапазоне, не переопределяем его тип
          if (dateObject.type !== 'range') {
            dateObject = {
              ...dateObject,
              type: 'flexible',
              canClick: true,
              isFlexible: true,
              isStart: thisDay === threeDaysBefore,
              isEnd: thisDay === threeDaysAfter,
            }
          }
        }
      }

      // Сложный маршрут
      if (hasSelectedDays) {
        const { type, isSelected } = getAlreadySelectedDays(fullDate)

        // Выбранный день
        if (startDate === fullDate) {
          return {
            ...dateObject,
            type: 'selected',
          }
        }

        if (isSelected) {
          return {
            ...dateObject,
            type: 'border',
            canClick: type === 'future',
          }
        }

        if (type === 'previous') {
          dateObject = {
            ...dateObject,
            type: 'disabled',
          }
        }
      }

      if (hasActiveDays && getDisabledDayInfo(fullDate)) {
        dateObject = {
          ...dateObject,
          type: 'disabled',
        }
      }

      if (!hasActiveDays && currentDay > thisDay) {
        dateObject = {
          ...dateObject,
          type: 'disabled',
        }
      }

      if (
        startDate &&
        !endDate &&
        maxRangeDays &&
        Math.abs(
          differenceDate({
            dateStart: startDate,
            dateEnd: fullDate,
            type: 'day',
          }),
        ) >= maxRangeDays
      ) {
        dateObject = {
          ...dateObject,
          type: 'disabled',
        }
      }

      // // Не активные дни
      // if (
      //   (isExcursion && getDisabledDayInfo(fullDate)) || // Не активные дни если есть список активных дней
      //   currentDay > thisDay // Прощедшие дни
      // ) {
      //   dateObject = {
      //     ...dateObject,
      //     type: 'disabled',
      //   }
      // }

      // Текущий день
      if (currentDay === thisDay) {
        return {
          ...dateObject,
          canClick: false,
          isCurrentDay: true,
        }
      }

      return dateObject
    },
  )

  return listDays
}
